import React from 'react';

const SimulatorContext = React.createContext(null);

export default SimulatorContext;
